/**
 * 投诉处理路由
 */
const CycleRouter = {
  path: 'cycle',
  name: 'cycle',
  meta: {
    requiresAuth: false,
    leftMenu: true          // false表示不需要左边菜单栏
  },
  component: () => import('@/views/Cycle/index')
}
export default CycleRouter
